import { isEmailOTPWalletConnector } from '../isEmailOTPWalletConnector/isEmailOTPWalletConnector.js';
import { isSocialWalletConnector } from '../isSocialWalletConnector/isSocialWalletConnector.js';

const isEmbeddedConnector = (connector) => isSocialWalletConnector(connector) || isEmailOTPWalletConnector(connector);

export { isEmbeddedConnector };
